export default __webpack_public_path__ + "static/media/biteBank.858d3b16.png";